module.exports = __webpack_public_path__ + "static/media/chat03-3.4b516279.svg";